export const PALETTE = {
  bullFill: "#00C076",
  bullStroke: "#00E68A",
  bearFill: "#FF3B30",
  bearStroke: "#FF5247",
  amber: "#F5A623",
  crosshair: "rgba(245,166,35,0.75)",
  mono: "'JetBrains Mono', monospace",
};

export interface ThemeColors {
  grid: string;
  axisText: string;
  lastLabelText: string;
  panelDiv: string;
}

export function themeColors(theme: string): ThemeColors {
  if (theme === "dark") {
    return { grid: "rgba(255,255,255,0.045)", axisText: "#7C879E", lastLabelText: "#0B0E14", panelDiv: "rgba(255,255,255,0.08)" };
  }
  return { grid: "rgba(15,23,42,0.06)", axisText: "#5A6473", lastLabelText: "#0B0E14", panelDiv: "rgba(15,23,42,0.10)" };
}
